<template>
  <div class="layout">
    <div class="mk_code_box">
      <div class="box">
        <h3>折扣度：</h3>
        <p>九折填9，八五折填8.5，免费填0，10以上就是多收钱了</p>
        <el-input v-model="codeform.promotion"></el-input>
      </div>
      <div class="box">
        <h3>可使用次数：</h3>
        <el-input v-model="codeform.times"></el-input>
      </div>
      <h1>优惠码：{{proCode}}</h1>
      <p class="buttom" @click="makeCode">生成</p>
    </div>    
    <div class="show_code_box">
      <!-- <ul class="code_box">
        <li>
          <span>优惠码</span>
          <span>优惠折扣</span>
          <span>使用次数</span>
          <span>已用次数</span>
        </li>
        <li v-for="(item,idx) in code_list" :key="idx">
          <span>{{item.proCode}}</span>
          <span>{{item.promotion}}</span>
          <span>{{item.times}}</span>
          <span>{{item.usedTimes}}</span>
        </li>
      </ul> -->
      <el-table :data='code_list'>
        <el-table-column prop='proCode' label='优惠码' />
        <el-table-column prop='promotion' label='优惠力度' />
        <el-table-column prop='times' label='优惠次数' />
        <el-table-column prop='usedTimes' label='已用次数' />
      </el-table>
    </div>
    
</div>  
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      codeform: {
        promotion: "",
        times: "",
        proCode: ""
      },
      proCode: "",
      code_list: []
    };
  },
  methods: {
    makeCode() {
      if (this.codeform.promotion === "" || this.codeform.times === "") {
        console.log("信息不完善，无法生成优惠码");
        return;
      }
      this.codeform.proCode = Math.random()
        .toString(36)
        .substr(2, 6);
      axios.post("/acapi/ac/promotion/creat", this.codeform).then(res => {
        if (res.data.statusCode === 200) {
          this.proCode = res.data.result.proCode;
          this.getAllCode();
        } else {
          console.log("网络不行");
        }
      });
    },
    getAllCode() {
      axios.get("/acapi/ac/promotion/allcode").then(res => {
        if (res.data.statusCode === 200) {
          this.code_list = [...res.data.result];
        } else {
          console.log("网络不行");
        }
      });
    }
  },
  created() {
    this.getAllCode();
  }
};
</script>

<style scoped>
.layout {
  display: flex;
  width: 100%;
  padding-top: 20px;
  padding-left: 20px;
}
.mk_code_box {
  margin-right: 100px;
}
.mk_code_box .box {
  margin: 20px;
}
.mk_code_box .box p {
  font-size: 14px;
  margin: 10px 0;
  padding-left: 10px;
}
.mk_code_box h1 {
  margin-left: 20px;
}
.mk_code_box .buttom {
  margin: 20px;
  border-radius: 10px;
  background-color: rgb(91, 91, 91);
  width: 50px;
  padding: 10px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}
.show_code_box ul {
  list-style: none;
}
.show_code_box ul li span {
  display: inline-block;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/estateforum/promotion_code.vue